// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { fetchRequest } from './index';

export const convertDataToServer = (
additionalCalculation) => (
{
  ...additionalCalculation,
  sum: convertFromRubToKop(additionalCalculation.sum),
  months: additionalCalculation.months.map(
    convertDataToServerAdditionalCalculationMonth
  )
});

export const convertDataFromServer = (
additionalCalculation) => (
{
  ...additionalCalculation,
  sum: convertFromKopToRub(additionalCalculation.sum),
  months: additionalCalculation.months.map(
    convertDataFromServerAdditionalCalculationMonth
  )
});

export const convertDataToServerAdditionalCalculationMonth = (
additionalCalculationMonth) => (
{
  ...additionalCalculationMonth,
  cost: convertFromRubToKop(additionalCalculationMonth.cost)
});

export const convertDataFromServerAdditionalCalculationMonth = (
additionalCalculationMonth) => (
{
  ...additionalCalculationMonth,
  cost: convertFromKopToRub(additionalCalculationMonth.cost)
});

const baseUrl = 'additionalCalculation';
const additionalCalculation = new CommonApi(
  baseUrl,
  'расчет стоимости доп расходов',
  convertDataToServer,
  convertDataFromServer
);

const changeStatus = async (data) =>


{
  const updated = await fetchRequest.put(`/${baseUrl}/changeStatus`, data);
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

export default {
  ...additionalCalculation,
  changeStatus
};
